/* eslint-disable import/no-cycle */
import Cookies from 'js-cookie';
import axios from 'axios';
import { apiClient, handleResponse } from './axios';

async function forgotPassword(email) {
  const body = JSON.stringify({ email, type: 'admin' });
  try {
    const response = await apiClient
      .post('/forgotPassword', body);
    const res = await handleResponse(response);
    return res;
  } catch (error) {
    return error.response;
  }
}

async function resetPassword(body) {
  try {
    const response = await apiClient
      .put('/resetPassword', body);
    const res = await handleResponse(response);
    return res;
  } catch (error) {
    return error.response;
  }
}

async function getStudentsWithCompany() {
  try {
    const response = await apiClient
      .get('/student/company');
    const res = await handleResponse(response);
    return res;
  } catch (error) {
    return error.response;
  }
}

async function refreshAuth(email, refreshToken) {
  const body = JSON.stringify({ email, refreshToken });
  try {
    const response = await axios
      .post('/refresh', body);
    const auth = await handleResponse(response);
    return auth;
  } catch (error) {
    return error.response;
  }
}

async function login(email, password, rememberMe) {
  const body = JSON.stringify({ email, password, rememberMe });
  try {
    const user = await apiClient
      .post('/administrator/login', body);
    return user;
  } catch (error) {
    return error.response;
  }
}

function updateUser(id, type, body) {
  try {
    if (type === 1) {
      return apiClient
        .put(`/administrator/${id}`, body)
        .then(handleResponse)
        .then((user) => user);
    }
    return null;
  } catch (error) {
    return error.response;
  }
}

async function getUserById(user) {
  try {
    const response = await apiClient
      .get(`/administrator/${user}`);
    const res = await handleResponse(response);
    return res;
  } catch (error) {
    return error.response;
  }
}

async function getAllAdmin() {
  try {
    const response = await apiClient
      .get('/administrator/');
    const res = await handleResponse(response);
    return res;
  } catch (error) {
    return error.response;
  }
}

async function addAdmin(body) {
  try {
    const response = await apiClient
      .post('/administrator/', body);
    const res = await handleResponse(response);
    return res;
  } catch (error) {
    return error.response;
  }
}

async function deleteAdmin(id) {
  try {
    const response = await apiClient
      .delete(`/administrator/${id}`);
    const res = await handleResponse(response);
    return res;
  } catch (error) {
    return error.response;
  }
}

async function getUserReferent() {
  try {
    const response = await apiClient
      .get('/customer');
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function searchUserReferent(search) {
  try {
    const response = await apiClient
      .get(`/customer/search/${search}`);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function getUserWithCompany() {
  try {
    const response = await apiClient
      .get('/user');
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function updateStudent(id, body) {
  try {
    const response = await apiClient
      .put(`/student/${id}`, body);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function updateCustomer(id, body) {
  try {
    const response = await apiClient
      .put(`/customer/${id}`, body);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function updateTeacher(id, body) {
  try {
    const response = await apiClient
      .put(`/teacher/${id}`, body);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function createStudent(body) {
  try {
    const response = await apiClient.post('/student', body);
    const student = await handleResponse(response);
    return student;
  } catch (error) {
    return error.response;
  }
}

async function createCustomer(body) {
  try {
    const response = await apiClient.post('/customer', body);
    const customer = await handleResponse(response);
    return customer;
  } catch (error) {
    return error.response;
  }
}

function generateLoginToken(auth) {
  const expiring = new Date();
  expiring.setMinutes(60 * 5 + 5);
  if (auth.token) {
    Cookies.set(
      'auth',
      auth.token,
      { expires: expiring },
      { secure: true },
      { sameSite: 'strict' },
    );
  }
  if (auth.refreshToken) {
    Cookies.set(
      'refresh',
      auth.refreshToken,
      { expires: expiring },
      { secure: true },
      { sameSite: 'strict' },
    );
  }
}

async function deleteStudent(userId, authorId) {
  try {
    const response = await apiClient
      .delete(`/student/${userId}/${authorId}`);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function deleteCustomer(userId) {
  try {
    const response = await apiClient
      .delete(`/customer/${userId}`);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function deleteTeacher(userId) {
  try {
    const response = await apiClient
      .delete(`/teacher/${userId}`);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

function logout() {
  localStorage.clear();
  sessionStorage.clear();
  Cookies.remove('auth');
  Cookies.remove('refresh');
  window.location.reload();
}

async function getStudentByCompany(companyId) {
  try {
    const response = await apiClient
      .get(`/student/company/${companyId}`);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function getStudentByGroup(groupId) {
  try {
    const response = await apiClient
      .get(`/student/group/${groupId}`);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function deleteUsersFromGroup(groupId, userId) {
  try {
    const response = await apiClient
      .delete(`/group/${groupId}/${userId}`);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function addUsersToSubGroup(groupId, subgroupId, userIds) {
  try {
    const response = await apiClient
      .put(`/group/subgroup/${groupId}/${subgroupId}`, { users: userIds });
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function deleteUsersFromSubGroup(groupId, subgroupId, usersId) {
  try {
    const response = await apiClient
      .put(`/group/subgroup/remove/${groupId}/${subgroupId}`, { users: usersId });
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function addUsersToGroup(groupId, userId) {
  try {
    const response = await apiClient
      .put(`/group/user/${groupId}/${userId}`, { user: userId });
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function exportStudentPdf(userId) {
  try {
    const response = await apiClient
      .get(`/export/pdf/user/${userId}`);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function getStudentsWithGrade(companyid) {
  try {
    const response = await apiClient
      .get(`/student/test/company/${companyid}/`);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function getStudentsWithGradeEW(companyid) {
  try {
    const response = await apiClient
      .get(`/student/grades/company/${companyid}`);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function getStudentsWithoutGradeBySemester(companyid, semester) {
  try {
    const response = await apiClient
      .get(`/student/notest/company/${companyid}/${semester}`);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function getStudentsWithoutGrade(companyid) {
  try {
    const response = await apiClient
      .get(`/student/notest/company/${companyid}/`);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function getArchivedStudents() {
  try {
    const response = await apiClient
      .get('/student/archived/');
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function getArchivedCustomers() {
  try {
    const response = await apiClient
      .get('/customer/archived/');
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function getAllStudents() {
  try {
    const response = await apiClient
      .get('/student/');
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function unarchiveStudent(studentId) {
  try {
    const response = await apiClient
      .put(`/student/archive/${studentId}/`);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function getArchivedTeachers() {
  try {
    const response = await apiClient
      .get('/teacher/archived/');
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function unarchiveTeacher(teacherId) {
  try {
    const response = await apiClient
      .put(`/teacher/archive/${teacherId}/`);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function unarchiveCustomer(customerId) {
  try {
    const response = await apiClient
      .put(`/customer/archive/${customerId}/`);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

const userServices = {
  login,
  logout,
  getArchivedCustomers,
  getAllStudents,
  unarchiveStudent,
  unarchiveTeacher,
  getArchivedTeachers,
  unarchiveCustomer,
  getArchivedStudents,
  getUserById,
  forgotPassword,
  generateLoginToken,
  refreshAuth,
  getUserReferent,
  getUserWithCompany,
  deleteStudent,
  deleteCustomer,
  deleteTeacher,
  updateStudent,
  updateCustomer,
  updateTeacher,
  createStudent,
  createCustomer,
  searchUserReferent,
  updateUser,
  getStudentByCompany,
  getStudentsWithoutGrade,
  deleteUsersFromGroup,
  addUsersToGroup,
  exportStudentPdf,
  getStudentsWithCompany,
  getAllAdmin,
  getStudentsWithoutGradeBySemester,
  deleteAdmin,
  deleteUsersFromSubGroup,
  addAdmin,
  addUsersToSubGroup,
  getStudentByGroup,
  getStudentsWithGrade,
  getStudentsWithGradeEW,
  resetPassword,
};

export default userServices;
